import gpiIcon from "../assets/icons/ascending Copy 67.svg";
import matchingIcon from "../assets/icons/ascending Copy 38.svg";
// import bicIcon from "../assets/icons/ascending Copy.svg";
import swiftIcon from "../assets/icons/ascending Copy 73.svg";
import searchIcon from "../assets/icons/ascending Copy 52.svg";
import postingIcon from "../assets/icons/Dashboard Copy.svg";
import alertsIcon from "../assets/icons/ascending Copy 45.svg";
import calcIcon from "../assets/icons/ascending Copy 2.svg";
import reportIcon from "../assets/icons/ascending Copy 59.svg";
// import claimsIcon from "../assets/icons/ascending Copy 39.svg";

const getModuleIcon = (id) => {
  switch (id) {
    case 1:
      return searchIcon;
    case 2:
      return swiftIcon;
    case 3:
      return alertsIcon;
    case 4:
      return matchingIcon;
    case 5:
      return gpiIcon;
    case 6:
      return calcIcon;
    case 7:
      return searchIcon;
    case 8:
      return postingIcon;
    case 9:
      return reportIcon;
    case 10:
      return matchingIcon;
    default:
      return searchIcon;
  }
};

export default getModuleIcon;
